export default {
  "unableToLoadStations": "Unable to load stations",
  "unableToLoadOutlets": "Unable to load outlets",
  "unableToFetchLaunchLink": "Unable to fetch launch link",
  "stationUpdated": "Station updated",
  "stationCreated": "Station created",
  "unableToSaveStation": "Unable to save station",
  "createStation": "Create station",
  "createRoute": "Create route",
  "activeStations": "Active stations",
  "stationsReadyToAcceptNewTickets": "Stations ready to accept new tickets.",
  "activeRoutes": "Active routes",
  "liveRoutingRulesForAllStations": "Live routing rules for all stations.",
  "ticketsInQueue": "Tickets in queue",
  "comingFromLiveKDSOrders": "Coming from live KDS orders.",
  "stationsAtAGlance": "Stations at a glance",
  "quickOverviewOfYourKitchenStationFleet": "Quick overview of your kitchen station fleet.",
  "launchLinks": "Launch links",
  "noStationsConfigured": "No stations configured",
  "createYourFirstKDSStationToBeginRoutingTickets": "Create your first KDS station to begin routing tickets.",
  "noOutletLinked": "No outlet linked",
  "active": "Active",
  "inactive": "Inactive",
  "launchLink": "Launch link",
  "launchLinkCopied": "Launch link copied",
  "selectAStationToGenerateALaunchLink": "Select a station to generate a launch link.",
  "secureStationURLRotatingOTP": "Secure station URL + rotating OTP.",
  "stationURL": "Station URL",
  "launchLinkNotReady": "Launch link not ready",
  "copyStationURL": "Copy station URL",
  "onetimePasscode": "One-time passcode",
  "expiresIn": "Expires in",
  "qRPending": "QR pending",
  "scanToOpenKDSStation": "Scan to open KDS station",
  "thisStationIsCurrentlyDisabledLaunchLinksWillStillWorkButServiceWillBeLimited": "This station is currently disabled. Launch links will still work, but service will be limited.",
  "product": "Product",
  "prepCategory": "Prep category",
  "productCategory": "Product category",
  "outlet": "Outlet",
  "outletType": "Outlet type",
  "defaultCatchall": "Default catch-all",
  "bar": "Bar",
  "dining": "Dining",
  "proShop": "Pro Shop",
  "halfwayHouse": "Halfway House",
  "chooseWhatTriggersThisRoute": "Choose what triggers this route",
  "chooseAMatchingValue": "Choose a matching value",
  "chooseAKDSStation": "Choose a KDS station",
  "editRoute": "Edit route",
  "productsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "Products marked as requiring KDS are sent to the first matching active route.",
  "moreSpecificRoutesWinAutomaticallyForExampleProductBeatsPrepCategoryAndPrepCategoryBeatsDefault": "More specific routes win automatically. For example, Product beats Prep category, and Prep category beats Default.",
  "whatShouldTriggerThisRoute": "What should trigger this route?",
  "chooseTrigger": "Choose trigger",
  "ePOSProduct": "ePOS product",
  "searchForAnEPOSProduct": "Search for an ePOS product",
  "searching": "Searching...",
  "searchAndSelectAProduct": "Search and select a product.",
  "choosePrepCategory": "Choose prep category",
  "chooseProductCategory": "Choose product category",
  "chooseOutlet": "Choose outlet",
  "unnamedOutlet": "Unnamed outlet",
  "chooseOutletType": "Choose outlet type",
  "defaultCatchesKDSrequiredItemsThatDoNotMatchAnotherRoute": "Default catches KDS-required items that do not match another route.",
  "sendTicketsTo": "Send tickets to",
  "chooseKDSStation": "Choose KDS station",
  "routeActive": "Route active",
  "useThisRouteWhenItMatches": "Use this route when it matches.",
  "cancel": "Cancel",
  "saveRoute": "Save route",
  "unableToLoadRoutes": "Unable to load routes",
  "routeUpdated": "Route updated",
  "routeCreated": "Route created",
  "unableToSaveRoute": "Unable to save route",
  "routeDeleted": "Route deleted",
  "unableToDeleteRoute": "Unable to delete route",
  "default": "Default",
  "routingRules": "Routing rules",
  "whenThisMatchesSendTicketsThereProductsMarkedAsRequiringKDSAreSentToTheFirstMatchingActiveRoute": "When this matches, send tickets there. Products marked as requiring KDS are sent to the first matching active route.",
  "noRoutingRulesYet": "No routing rules yet",
  "createADefaultRouteToCatchUnmatchedKDSItems": "Create a default route to catch unmatched KDS items.",
  "createPrepCategoryRoutesSuchAsDrinksBarAndFoodKitchen": "Create prep category routes such as Drinks → Bar and Food → Kitchen.",
  "edit": "Edit",
  "deleteRoute": "Delete route",
  "thisRoutingRuleWillBeRemovedImmediately": "This routing rule will be removed immediately.",
  "stationNameIsRequired": "Station name is required",
  "editKDSStation": "Edit KDS station",
  "createKDSStation": "Create KDS station",
  "stationName": "Station name",
  "mainKitchen": "Main Kitchen",
  "stationActive": "Station active",
  "allowThisStationToReceiveRoutedKDSTickets": "Allow this station to receive routed KDS tickets.",
  "soundEnabled": "Sound enabled",
  "playAToneWhenNewTicketsArrive": "Play a tone when new tickets arrive.",
  "autobumpMinutes": "Auto-bump minutes",
  "automaticallyCompleteItemsAfterThisManyMinutesUse0ToKeepOff": "Automatically complete items after this many minutes. Use 0 to keep off.",
  "saveStation": "Save station",
  "stations": "Stations",
  "selectAStationToManageLaunchLinks": "Select a station to manage launch links.",
  "createYourFirstStation": "Create your first station",
  "stationsPowerTheKDSLayoutAndLaunchLinks": "Stations power the KDS layout and launch links.",
  "routesDecideWhereKDSrequiredItemsGo": "Routes decide where KDS-required items go.",
  "disabled": "Disabled",
  "editStation": "Edit station",
  "stationDetails": "Station details",
  "configurationSummaryForThisStation": "Configuration summary for this station.",
  "on": "On",
  "off": "Off",
  "autobump": "Auto-bump",
  "technicalKeyKey": "Technical key: {key}",
  "selectAStationToViewDetails": "Select a station to view details.",
  "done": "Done",
  "queued": "Queued",
  "inProgress": "In progress",
  "tapAgainToUndo": "Tap again to undo",
  "order": "Order",
  "tableTable": "Table {table}",
  "countCover": "{count} cover",
  "countCovers": "{count} covers",
  "completedAgeAgo": "Completed {age} ago",
  "startAll": "Start all",
  "bumpAll": "Bump all",
  "reconnectingToKitchenService": "Reconnecting to kitchen service...",
  "liveUpdatesDegradedUsingFallbackPolling": "Live updates degraded, using fallback polling...",
  "unableToVerifyOTPCheckTheCodeOrConnectivity": "Unable to verify OTP. Check the code or connectivity.",
  "unableToStartItemConnectionLost": "Unable to start item. Connection lost.",
  "unableToBumpItemConnectionLost": "Unable to bump item. Connection lost.",
  "unableToRecallItemConnectionLost": "Unable to recall item. Connection lost.",
  "kitchenDisplay": "Kitchen Display",
  "syncing": "Syncing…",
  "syncedSecondssAgo": "Synced {seconds}s ago",
  "live": "Live",
  "reconnecting": "Reconnecting",
  "lock": "Lock",
  "noOrdersHereYet": "No orders here yet.",
  "resolvingStation": "Resolving station…",
  "unableToLocateStation": "Unable to locate station.",
  "enterOnetimeCodeFromManager": "Enter one-time code from manager",
  "verifyingCode": "Verifying code…",
  "terminalAccessRequired": "Terminal access required",
  "codeDigitDigit": "Code digit {digit}",
  "refreshCode": "Refresh code",
  "requestFailedPleaseTryAgain": "Request failed. Please try again.",
  "food": "Food",
  "drinks": "Drinks",
  "dessert": "Dessert",
  "kitchen": "Kitchen",
  "other": "Other",
  "minutesMin": "{minutes} min",
  "deleteRouteConfirm": "Delete route?",
  "station": "KDS station",
  "void": "Cancelled",
  "recalled": "Recalled",
  "createStationHeading": "Create Station",
  "stationNotFound": "This KDS station is unavailable.",
  "routeNotFound": "This routing rule no longer exists.",
  "invalidSettings": "Check the station settings and try again.",
  "invalidRouteType": "Choose a valid routing criterion.",
  "itemId": "Item identifier",
  "itemTag": "Item tag",
  "menu": "Menu"
};
